const normalizeRoleToken = (value = "") => String(value || "").trim().toLowerCase();

export const hasSuperAdminRole = (user = null) => {
	const roleType = normalizeRoleToken(user?.role?.role_type || user?.user_role_type);
	const roleName = normalizeRoleToken(user?.role?.role_name || user?.user_role_name || user?.user_role);
	return roleType === "superadmin" || roleName === "superadmin";
};

export const isSystemSuperAdmin = (user = null) => Number(user?.user_id) === 1;

export const hasSuperAdminAccess = (user = null) =>
	isSystemSuperAdmin(user) || hasSuperAdminRole(user);

export const isAdminRole = (user = null) => {
	const roleType = normalizeRoleToken(user?.role?.role_type);
	const roleName = normalizeRoleToken(user?.role?.role_name || user?.user_role_name || user?.user_role);
	return roleType === "admin" || roleName === "admin";
};

export const isAdminLike = (user = null) =>
	hasSuperAdminAccess(user) || isAdminRole(user);
